(function () {
    'use strict';

    var observer;
    var lastScrollPosition = window.scrollY;
    var scrollDirection = 'down';

    function updateSectionDirection(section) {
        section.classList.toggle('is-visible', scrollDirection === 'down');
    }

    function updateScrollDirection() {
        var currentScrollPosition = window.scrollY;

        if (currentScrollPosition === lastScrollPosition) {
            return;
        }

        var newDirection = currentScrollPosition > lastScrollPosition ? 'down' : 'up';
        lastScrollPosition = currentScrollPosition;

        if (newDirection === scrollDirection) {
            return;
        }

        scrollDirection = newDirection;

        var visibleSections = document.querySelectorAll(
            '[data-scrolling-text][data-scrolling-text-in-view="true"]'
        );

        for (var i = 0; i < visibleSections.length; i++) {
            updateSectionDirection(visibleSections[i]);
        }
    }

    function initializeSection(section) {
        if (section.dataset.scrollingTextInitialized === 'true') {
            return;
        }

        section.dataset.scrollingTextInitialized = 'true';

        if (!('IntersectionObserver' in window)) {
            section.classList.add('is-visible');
            return;
        }

        observer.observe(section);
    }

    function initialize(root) {
        if (root.matches && root.matches('[data-scrolling-text]')) {
            initializeSection(root);
        }

        var sections = root.querySelectorAll('[data-scrolling-text]');

        for (var i = 0; i < sections.length; i++) {
            initializeSection(sections[i]);
        }
    }

    if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                var isInView = entries[i].isIntersecting && entries[i].intersectionRatio >= 0.2;
                entries[i].target.dataset.scrollingTextInView = String(isInView);

                if (isInView) {
                    updateSectionDirection(entries[i].target);
                }
            }
        }, {
            threshold: 0.2,
            rootMargin: '0px 0px -10% 0px'
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initialize(document);
        window.addEventListener('scroll', updateScrollDirection, { passive: true });
    });

    document.addEventListener('shopify:section:load', function (event) {
        initialize(event.target);
    });
})();
